export default "__VITE_ASSET__CGQ_cyYl__"